enum WalletsActionType {
    WALLETS_REQUEST_DATA = "WALLETS_REQUEST_DATA",
    WALLETS_LOAD_WALLETS_DATA = "WALLETS_LOAD_WALLETS_DATA",
    WALLETS_LOAD_CURRENCY_DATA = "WALLETS_LOAD_CURRENCY_DATA",
    WALLETS_DISPLAY_ERROR = "WALLETS_DISPLAY_ERROR",
}

export default WalletsActionType;